import { useTranslation } from 'react-i18next';
import { Button } from './base/Button';
import { Tooltip } from './Tooltip';
import { IconCalendar } from './DesignIcons';
import { tertiaryIconButtonStyle } from './buttonStyles';
import styles from './OpenCalendarButton.module.css';

interface OpenCalendarButtonProps {
  // What this button opens. Every instance renders the same icon and the same
  // tooltip, so the label is the only thing telling a screen reader which of
  // 52 week buttons — or which person's row — it is on.
  label: string;
  onClick: () => void;
}

// The icon button that opens the individual calendar. Shared by the year view's
// week header and the week overview's heatmap rows so the two cannot drift
// apart in appearance or accessible naming.
export const OpenCalendarButton = ({ label, onClick }: OpenCalendarButtonProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      trigger={
        <Button type="tertiary" onClick={onClick} styles={{ root: tertiaryIconButtonStyle }}>
          <IconCalendar aria-hidden={false} role="img" aria-label={label} />
        </Button>
      }
      content={<span className={styles.tooltip}>{t('week-overview-open-calendar')}</span>}
    />
  );
};
